import styled, { keyframes } from 'styled-components'
import { SmallButton, T } from '../../components'
import { ReactNode } from 'react'
import { colors } from '../../components/colors'

const accordionExpand = keyframes`
  0% {
    transform: scaleY(0);
    transform-origin: top;
    opacity: 0;
  }
  50% {
    transform: scaleY(1.1);
    transform-origin: top;
    opacity: 0.5;
  }
  100% {
    transform: scaleY(1);
    transform-origin: top;
    opacity: 1;
  }
`

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  z-index: 1000;
  overflow-y: auto;
`

const ModalContent = styled.div`
  background-color: ${colors.Map.modal.background};
  border-radius: 12px;
  width: calc(100% - 4rem);
  max-width: 400px;
  height: 430px;
  margin-top: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1.5rem;
  animation: ${accordionExpand} 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  transform-origin: top;
`

export const LegendItem = styled.div`
  display: flex;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  color: ${colors.Map.modal.text};
  height: 50px;
  /* Target Body2 styled components within LegendItem */
  & > div > div:last-child {
    color: #d86d1e;
    text-align: left;
  }
  img.icon {
    width: 50px;
    height: 50px;
  }
`

export const LegendContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

interface LegendModalProps {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
}

export function LegendModal({ isOpen, onClose, children }: LegendModalProps) {
  if (!isOpen) return null

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <SmallButton onClick={onClose}>
          <T id="CLOSE" />
        </SmallButton>
        {children}
      </ModalContent>
    </ModalOverlay>
  )
}
